<template>
  <svg
    id="svg-my-en-name"
    class="w-full fill-flax-smoke-900"
    viewBox="0 0 560 100"
    style="enable-background: new 0 0 560 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g style="font-family: 'Bricolage Grotesque', sans-serif">
      <text
        class="translate-y-full will-change-auto"
        x="0"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >A</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="52"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >J</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="77"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >T</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="116"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >E</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="158"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >N</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="250"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >C</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="300"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >A</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="350"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >N</text
      >
      <text
        class="translate-y-full will-change-auto"
        x="402"
        y="80"
        font-size="80"
        font-weight="800"
        letter-spacing="2"
        >I</text
      >
    </g>
  </svg>
</template>
